const filmsData = [
  {
    id: 1,
    image: process.env.PUBLIC_URL + '/assets/images/1.jpg',
    title: 'Star Wars: Episode IV',
    year: '1977',
    nation: 'United States',
    description: '"Star Wars: Episode IV - A New Hope" is a 1977 American epic space-opera film directed by George Lucas. The movie follows the journey of a young farm boy, Luke Skywalker, and his allies as they attempt to rescue Princess Leia from the clutches of the Empire. The film is set in a galaxy far, far away and is the first part of the Star Wars original trilogy.',
  },

  {
    id: 2,
    image: process.env.PUBLIC_URL + '/assets/images/2.jpg',
    title: 'Weathering with You',
    year: '2019',
    nation: 'Japan',
    description: '"Weathering with You" is a 2019 Japanese animated romantic fantasy film directed by Makoto Shinkai. The movie follows the story of a 16-year-old boy named Hodaka Morishima, who runs away from his rural home to Tokyo and befriends Hina Amano, an orphaned girl who can manipulate the weather. The film grossed $193.8 million worldwide.',
  },

  {
    id: 3,
    image: process.env.PUBLIC_URL + '/assets/images/3.jpeg',
    title: 'Incantation',
    year: '2022',
    nation: 'Taiwan',
    description: '"Incantation" is a 2022 Taiwanese found footage supernatural folk horror film directed by Kevin Ko. The movie is based on a contemporary religious possession incident in Kaohsiung, in which a family of six became possessed by various deities. The film has been highly successful at the box office, becoming the highest-grossing Taiwanese movie of 2022.',
  },

  {
    id: 4,
    image: process.env.PUBLIC_URL + '/assets/images/4.jpg',
    title: 'The Post-Truth World',
    year: '2022',
    nation: 'Taiwan',
    description: 'Chang, a former rising sports star who has been jailed for murdering his girlfriend seven years prior, escapes from the prison and brazenly takes hostage of Liu, once a top media personality. As public attention on the case continues to heighten, Liu decides to investigate Chang as a way to get back in the spotlight.',
  },

  {
    id: 5,
    image: process.env.PUBLIC_URL + '/assets/images/5.jpg',
    title: 'The Victims Game',
    year: '2020',
    nation: 'Taiwan',
    description: 'The Victims Game is a 2020 Taiwanese Netflix original series starring Joseph Chang, Ann Hsu and Jason Wang. The plot revolves around the forensic scientist with Asperger syndrome Fang Yi-jen (Joseph Chang) and the investigative journalist Hsu Hai-yin (Ann Hsu), investigating a case involving Fang Yi-jen daughter.',
  },

  {
    id: 6,
    image: process.env.PUBLIC_URL + '/assets/images/6.jpg',
    title: 'The Bridge Curse',
    year: '2020',
    nation: 'Taiwan',
    description: 'The Bridge Curse (Chinese: 女鬼橋) is a 2020 Taiwanese horror mystery thriller film directed by Lester Hsi, starring Summer Meng, J.C. Lin, Chang Ning and Vera Yan. It is based on the legend of the haunted bridge at Tunghai University. The film received a video game adaptation, The Bridge Curse: Road to Salvation, which was released on Steam on 25 August 2022.The film will receive a sequel, titled The Bridge Curse: Ritual.',
  },

  {
    id: 7,
    image: process.env.PUBLIC_URL + '/assets/images/7.jpg',
    title: 'Elemental',
    year: '2023',
    nation: 'United States',
    description: '"Elemental" is a 2023 American computer-animated romantic comedy-drama film produced by Walt Disney Pictures and Pixar Animation Studios. The movie follows Ember and Wade, an unlikely pair in a city where fire-, water-, land- and air-residents live together. The film is based on director Peter Sohn childhood in New York and was theatrically released on June 16, 2023.',
  },

  {
    id: 8,
    image: process.env.PUBLIC_URL + '/assets/images/8.jpg',
    title: 'Monsters, Inc.',
    year: '2001',
    nation: 'United States',
    description: '"Monsters, Inc." is a 2001 American computer-animated comedy film produced by Pixar Animation Studios for Walt Disney Pictures. The movie is set in Monstropolis, a city inhabited by monsters, who scare human children to collect their screams, which power the city. The film follows the story of two monsters, Sulley and Mike, who discover that a little girl is not actually dangerous.',
  },

  {
    id: 9,
    image: process.env.PUBLIC_URL + '/assets/images/9.jpg',
    title: 'Zootopia',
    year: '2016',
    nation: 'United States',
    description: '"Zootopia" is a 2016 American computer-animated buddy cop comedy film produced by Walt Disney Animation Studios. The movie follows the story of a rabbit police officer, Judy Hopps, and a con artist fox, Nick Wilde, who team up to solve a conspiracy in the mammal metropolis of Zootopia. The film was critically acclaimed and grossed over $1 billion worldwide.',
  },


];

export default filmsData;